"use strict";

var CashierSdk = require('@nackle/cashier-sdk');
var _require = require('../utils/endpoints'),
  cashierUrl = _require.cashierUrl;
var _require2 = require('../utils/error'),
  throwServiceError = _require2.throwServiceError;
var SERVICE_NAME = 'cashier';
module.exports = function (_ref) {
  var fetch = _ref.fetch;
  var sdk = new CashierSdk(cashierUrl, fetch);
  var getMediaValueByCountry = function getMediaValueByCountry() {
    return new Promise(function ($return, $error) {
      var $Try_1_Post = function () {
        try {
          return $return();
        } catch ($boundEx) {
          return $error($boundEx);
        }
      };
      var $Try_1_Catch = function (error) {
        try {
          throwServiceError(SERVICE_NAME, error, 'getMediaValueByCountry');
          return $Try_1_Post();
        } catch ($boundEx) {
          return $error($boundEx);
        }
      };
      try {
        return Promise.resolve(sdk.getMediaValueByCountry()).then($return, $Try_1_Catch);
      } catch (error) {
        $Try_1_Catch(error)
      }
    });
  };
  var getPointBalance = function getPointBalance(personId) {
    return new Promise(function ($return, $error) {
      var response;
      var $Try_2_Post = function () {
        try {
          return $return();
        } catch ($boundEx) {
          return $error($boundEx);
        }
      };
      var $Try_2_Catch = function (error) {
        try {
          // avoid failure if there is an issue with Cashier or person doesn't have bank account
          if (error.reason.indexOf('Account not found for person-id') === 0) {
            return $return({
              success: true,
              hasAccount: false,
              balance: null
            });
          } else {
            return $return({
              success: false,
              hasAccount: null,
              balance: null
            });
          }
          return $Try_2_Post();
        } catch ($boundEx) {
          return $error($boundEx);
        }
      };
      try {
        return Promise.resolve(sdk.getPointBalance(personId)).then(function ($await_4) {
          try {
            response = $await_4;
            return $return({
              success: true,
              hasAccount: true,
              balance: response.accountBalance
            });
          } catch ($boundEx) {
            return $Try_2_Catch($boundEx);
          }
        }, $Try_2_Catch);
      } catch (error) {
        $Try_2_Catch(error)
      }
    });
  };
  return {
    getMediaValueByCountry: getMediaValueByCountry,
    getPointBalance: getPointBalance
  };
};
//# sourceMappingURL=cashier.js.map